// Component should have a .sidescroll class at the top level,
// with a .sidescroll-list class for the scrollable content.
// Import the twig partial outside of the sidescroll list

const sidescrollers: Array<HTMLElement> = [
  ...document.querySelectorAll<HTMLElement>(".sidescroll"),
];

const setupSidescrollers = () => {
  if (sidescrollers.length === 0) return;

  sidescrollers.forEach((sidescroller) => {
    const sidescrollList: HTMLElement | null = sidescroller.querySelector(".sidescroll-list");
    const scrollbar = sidescroller.querySelector(".sidescroll-scrollbar") as HTMLElement;
    const bar = scrollbar?.querySelector(".scrollbar-bar") as HTMLElement;

    function updateVisibility() {
      if (!sidescrollList) return;
      if (sidescrollList.scrollWidth <= sidescrollList.clientWidth) {
        scrollbar.style.display = "none";
      } else {
        scrollbar.style.display = "";
      }
    }

    function updateSidescrollScrollbar() {
      const list = sidescroller.querySelector(".sidescroll-list") as HTMLElement;

      if (!list || !bar || !scrollbar) return;

      const scrollbarWidth = scrollbar.offsetWidth;
      const padding = 16;
      const trackWidth = scrollbarWidth - 2 * padding;

      const scrollLeft = list.scrollLeft;
      const scrollWidth = list.scrollWidth;
      const clientWidth = list.clientWidth;

      const progress = scrollLeft / (scrollWidth - clientWidth);
      const barWidth = Math.max(0, (clientWidth / scrollWidth) * trackWidth);
      const barLeft = progress * (trackWidth - barWidth);

      bar.style.width = `${barWidth}px`;
      bar.style.transform = `translateX(${barLeft}px)`;
    }

    // Show/hide before sizing: hidden bar measures 0, prevents layout shift.
    function runUpdates() {
      updateVisibility();
      updateSidescrollScrollbar();
    }

    if (sidescrollList) {
      sidescrollList.addEventListener("scroll", updateSidescrollScrollbar);

      // Wait for all images to load before updating
      const images = Array.from(sidescrollList.querySelectorAll("img"));
      let loadedCount = 0;
      const totalImages = images.length;

      if (totalImages === 0) {
        runUpdates();
      }

      images.forEach((img) => {
        if (img.complete) {
          loadedCount++;
          if (loadedCount === totalImages) runUpdates();
        } else {
          img.addEventListener("load", () => {
            loadedCount++;
            if (loadedCount === totalImages) runUpdates();
          });
        }
      });
    }

    window.addEventListener("resize", runUpdates);
  });
};

setupSidescrollers();
